import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { JobRequestListDto, JobRequestListDtoPageable } from "@/data/job-requests/types/JobRequest";
import { IPageableFetcherRenderProps } from "@/hooks/http";
import { useHasScrolledToElement } from "@/hooks/Viewport";
import { InfoboxSection } from "@/views/components/Page";

import { JobRequestsListRenderer } from "./components";

interface IAllJobsListProps extends IPageableFetcherRenderProps<JobRequestListDto, JobRequestListDtoPageable> {
  onRecordUpdate?: (record: JobRequestListDto) => void;
}

export const JobsList: FC<IAllJobsListProps> = ({ onRecordUpdate, ...fetcherState }) => {
  const { t } = useTranslation("public");

  const [, lastJobOfferRef] = useHasScrolledToElement();

  const renderEmpty = useCallback(() => {
    return (
      <InfoboxSection
        heading={t("LANDING_PAGE.JOB_REQUEST.LIST.NO_MATCHING_JOBS")}
        description={t("LANDING_PAGE.JOB_REQUEST.LIST.NO_MATCHING_JOBS_TEXT")}
      />
    );
  }, []);

  return (
    <JobRequestsListRenderer
      {...fetcherState}
      lastJobOfferRef={lastJobOfferRef}
      renderEmpty={renderEmpty}
      onRecordUpdate={onRecordUpdate}
      trackingSource="Search"
    />
  );
};
